export default __webpack_public_path__ + "static/media/solitaire.7420ba1c.png";